import React from 'react';
import '../styles/Avatar.css';

/**
 * Avatar component that renders SVG content directly
 * 
 * @param {string} svgContent - The SVG markup as a string
 * @param {string} alt - Alt text for accessibility
 * @param {string} className - Additional CSS classes
 * @param {object} style - Inline styles
 */
const Avatar = ({ svgContent, alt = "Avatar", className = "", style = {} }) => {
    return (
        <div 
            className={`avatar-container ${className}`}
            style={style}
            dangerouslySetInnerHTML={{ __html: svgContent }}
            role="img"
            aria-label={alt}
        />
    );
};

export default Avatar;
